var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #494848;\n      }\n\n      .cls-3 {\n        opacity: 0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "learning"
  }, /*#__PURE__*/React.createElement("g", {
    id: "learning_group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "learning_path_4",
    className: "cls-1",
    points: "20.4 2.45 23 13.03 22.95 13.05 9.83 5.11 9.82 5.06 20.4 2.45"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "learning_path_3",
    className: "cls-1",
    x: 4.44,
    y: 11.83,
    width: 10.9,
    height: 5.45,
    transform: "translate(8.96 -3.02) rotate(31.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "learning_path_2",
    className: "cls-1",
    x: 8.18,
    y: 10.91,
    width: 10.9,
    height: 5.45,
    transform: "translate(-5.09 18.24) rotate(-58.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "learning_path_1",
    className: "cls-1",
    x: 0.7,
    y: 12.75,
    width: 10.9,
    height: 5.45,
    transform: "translate(-10.27 12.73) rotate(-58.82)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLearning);
export default __webpack_public_path__ + "static/media/icon_learning.cb54c2cef3a1c019f652799d3f3b8a67.svg";
export { ForwardRef as ReactComponent };